export const toSentenceCase = (str?: string | null): string | undefined | null => {
  if (!str) {
    return str
  }
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export const snakeToCamel = (fieldName: string): string => {
  return fieldName
    .toLowerCase()
    .replace(/([-_][a-z])/g, (group) => group.toUpperCase().replace('-', '').replace('_', ''))
}

export const getContestPoints = (
  points: number,
  symbol: string,
  formatMoney: (n: number) => string
) => {
  return symbol === '$' ? formatMoney(points) : `${points}${symbol}`
}
